export const buildEnvironment = {
"buildId":"186009",
"buildDate":"2023-01-27T18:06:31.853Z",
"buildTimeStamp":1674842791853,
"ngVersion":"13.3.2",
"version":"6.0.4694",
"api":"21.01",
"environment":"prod",
"production":true
};